import { gsap } from 'gsap';

class Windowshades {
    constructor(element) {
        this.element = element;
        this.windowshades = this.element.querySelectorAll('.windowshade');
    }

    init() {
        this.windowshades.forEach((windowshade) => {
            windowshade.addEventListener(
                'click',
                this.onWindowshadeClick.bind(this)
            );
        });
    }

    onWindowshadeClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.currentTarget.getAttribute('aria-expanded') === 'true') {
            this.deactivateWindowshade(event.currentTarget);
        } else {
            this.activateWindowshade(event.currentTarget);
        }
    }

    // eslint-disable-next-line class-methods-use-this
    isMobile() {
        return window.matchMedia('(max-width: 767px)').matches;
    }

    activateWindowshade(windowshade) {
        if (this.isMobile()) {
            windowshade.scrollIntoView({ behavior: 'smooth' });
        }

        const target = windowshade.getAttribute('aria-controls');
        const windowshadeContent = this.element.querySelector(`#${target}`);
        const icon = windowshade.querySelector('i');

        this.setAriaExpanded(target, 'true');
        this.activateWithin(windowshadeContent);
        this.activateWithin(windowshade);

        if (icon) {
            icon.classList.remove('fa-plus');
            icon.classList.add('fa-minus');
        }

        gsap.to(windowshadeContent, {
            duration: 0.3,
            opacity: 1,
            display: 'block'
        });

        gsap.set(windowshadeContent, { height: 'auto' });

        gsap.from(windowshadeContent, {
            duration: 0.3,
            height: 0,
            onComplete: () => {
                // eslint-disable-next-line no-param-reassign
                windowshadeContent.style.height = 'auto';
            }
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'windowshade_view',
            windowshadeName: windowshade.textContent.trim()
        });
    }

    setAriaExpanded(targetId, value) {
        const controllers = this.element.querySelectorAll(
            `[aria-controls="${targetId}"]`
        );
        controllers.forEach((controller) => {
            controller.setAttribute('aria-expanded', value);
        });
    }

    deactivateWindowshade(windowshade) {
        const target = windowshade.getAttribute('aria-controls');
        const targetElement = this.element.querySelector(`#${target}`);
        const icon = windowshade.querySelector('i');

        this.setAriaExpanded(target, 'false');
        this.deactivateWithin(windowshade);
        this.deactivateWithin(targetElement);

        if (icon) {
            icon.classList.remove('fa-minus');
            icon.classList.add('fa-plus');
        }

        gsap.to(targetElement, {
            duration: 0.3,
            opacity: 0,
            height: 0,
            onComplete: () => {
                targetElement.style.display = 'none';
            }
        });
    }

    deactivateWithin(element) {
        if (element.getAttribute('data-activeclass')) {
            this.removeClasses(
                element,
                element.getAttribute('data-activeclass')
            );
            this.addClasses(
                element,
                element.getAttribute('data-inactiveclass')
            );
        }
        element.querySelectorAll('[data-activeclass]').forEach((el) => {
            this.removeClasses(el, el.getAttribute('data-activeclass'));
            this.addClasses(el, el.getAttribute('data-inactiveclass'));
        });
    }

    activateWithin(element) {
        if (element.getAttribute('data-activeclass')) {
            this.removeClasses(
                element,
                element.getAttribute('data-inactiveclass')
            );
            this.addClasses(element, element.getAttribute('data-activeclass'));
        }
        element.querySelectorAll('[data-activeclass]').forEach((el) => {
            this.removeClasses(el, el.getAttribute('data-inactiveclass'));
            this.addClasses(el, el.getAttribute('data-activeclass'));
        });
    }

    // eslint-disable-next-line class-methods-use-this
    removeClasses(element, classNames) {
        const classes = classNames.split(' ');
        classes.forEach((className) => {
            if (className) element.classList.remove(className);
        });
    }

    // eslint-disable-next-line class-methods-use-this
    addClasses(element, classNames) {
        // eslint-disable-next-line no-param-reassign
        element.className += ` ${classNames}`;
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const windowshades = document.getElementsByClassName('windowshades');
    Array.from(windowshades).forEach((windowshadesElement) => {
        const windowshadesInstance = new Windowshades(windowshadesElement);
        windowshadesInstance.init();
    });
});
